module.exports = __webpack_public_path__ + "media/app/assets/images/sandisk-72ff4f3ba1d185bfa6d21b666502e1f2.jpg";